import { Col, Row, View } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FC } from "react";

// Light tints suitable for page header gradients
const GRADIENT_COLORS = [
  { name: "Blue", value: "#d7ebfb" },
  { name: "Purple", value: "#e5c8f7" },
  { name: "Green", value: "#d7f3ed" },
  { name: "Orange", value: "#ffe4ad" },
  { name: "Pink", value: "#e8bdd7" },
  { name: "Teal", value: "#b1ece7" },
  { name: "Lavender", value: "#dcdeff" },
  { name: "Neutral", value: "#e8eaee" },
];

export interface GradientValue {
  left: string;
  right: string;
}

interface ColorPickerProps {
  gradient: GradientValue;
  onGradientChange: (gradient: GradientValue) => void;
}

const ColorSwatch: FC<{ color: string; isSelected: boolean; onClick: () => void; label: string }> = ({
  color,
  isSelected,
  onClick,
  label,
}) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={`Select ${label}`}
    style={{
      width: 28,
      height: 28,
      borderRadius: "50%",
      backgroundColor: color,
      border: isSelected ? "2px solid var(--color-blue-70)" : "1px solid var(--color-neutral-30)",
      cursor: "pointer",
      padding: 0,
    }}
  />
);

export const ColorPicker: FC<ColorPickerProps> = ({ gradient, onGradientChange }) => (
  <Col gridGap="dimensions.spacing.200">
    <Row alignItems="center" gridGap="dimensions.spacing.300">
      <Col gridGap="dimensions.spacing.100">
        <Text fontSize="T100" fontWeight="bold">
          {getString("spaces.edit.leftColor")}
        </Text>
        <Row gridGap="dimensions.spacing.100">
          {GRADIENT_COLORS.map((c) => (
            <ColorSwatch
              key={`left-${c.name}`}
              color={c.value}
              isSelected={gradient.left === c.value}
              onClick={() => onGradientChange({ ...gradient, left: c.value })}
              label={`${c.name} left`}
            />
          ))}
        </Row>
      </Col>
      <Col gridGap="dimensions.spacing.100">
        <Text fontSize="T100" fontWeight="bold">
          {getString("spaces.edit.rightColor")}
        </Text>
        <Row gridGap="dimensions.spacing.100">
          {GRADIENT_COLORS.map((c) => (
            <ColorSwatch
              key={`right-${c.name}`}
              color={c.value}
              isSelected={gradient.right === c.value}
              onClick={() => onGradientChange({ ...gradient, right: c.value })}
              label={`${c.name} right`}
            />
          ))}
        </Row>
      </Col>
    </Row>
    <View
      height={32}
      borderRadius="dimensions.border.radius.300"
      style={{ background: `linear-gradient(to right, ${gradient.left}, ${gradient.right})` }}
    />
  </Col>
);
